import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getAnonCompanyData,
  getLaunchWeekData,
  postPayrollFirstPayDate,
  postUploadDocument,
} from './api';

export const SLICE_NAME = 'productGrowth';

export const createPayrollFirstPayDate = createAsyncThunk<string, string>(
  `${SLICE_NAME}/createPayrollFirstPayDate`,
  (payload, { rejectWithValue }) =>
    postPayrollFirstPayDate(payload).catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const createUploadDocument = createAsyncThunk(
  `${SLICE_NAME}/createUploadDocument`,
  (document: File, { rejectWithValue }) =>
    postUploadDocument(document).catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const fetchDashboardBanner = createAsyncThunk(
  `${SLICE_NAME}/launchWeek`,
  async (_, { rejectWithValue }) =>
    getLaunchWeekData().catch(error =>
      rejectWithValue(error.body || error.message)
    )
);

export const fetchAnonCompanyData = createAsyncThunk(
  `${SLICE_NAME}/fetchAnonCompanyData`,
  async (
    payload: {
      companyUuid: string;
      extractionProcessId: string;
      step: 'business_details' | 'team_members';
    },
    { rejectWithValue }
  ) =>
    getAnonCompanyData(payload).catch(error =>
      rejectWithValue(error.body || error.message)
    )
);
